import { render } from "./OtherMethods.vue?vue&type=template&id=7e4eaa9d&lang=pug"
import script from "./OtherMethods.vue?vue&type=script&lang=js"
export * from "./OtherMethods.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__